import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Dashboard from '../views/Dashboard';
import styles from './Layout.module.scss';
import HeaderView from '../components/HeaderView';
import Routes from '../types/routes';
import Nav from '../components/Nav';
import MarketLay from '../views/Market';
// import Manage from '../views/Manage';
import APIDetailLay from '../views/Market/APIDetail';
import WalletList from '../views/Manage/wallet/WalletList';
import PublishAPILay from '../views/Market/PublishAPILay';

const Layout: React.FC = () => (
  <div className={styles.layout}>
    <HeaderView />
    <div className={styles.bottom}>
      <div className={styles.left}>
        <Nav />
      </div>
      <div className={styles.right}>
        <Switch>
          <Route path={Routes.Dashboard}>
            <Dashboard />
          </Route>
          <Route path={Routes.Market}>
            <MarketLay />
          </Route>
          <Route path={Routes.ManageWallet}>
            <WalletList />
          </Route>
          <Route path={Routes.ManageExchange}>
            <div>nope</div>
          </Route>
          <Route path={Routes.Certificate}>
            <div>nope</div>
          </Route>
          <Route path={Routes.Publish}>
            <PublishAPILay />
          </Route>
          <Route path={Routes.APIDetail}>
            <APIDetailLay />
          </Route>
          <Redirect from="/" to={Routes.Dashboard} />
        </Switch>
      </div>
    </div>
  </div>
);

export default Layout;
